import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getAllRoles = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.USER_MANAGEMENT.GET_ALL_ROLES
  );
};

export default getAllRoles;
